import {array} from "./array";
import * as Buffer from "buffer";


// noinspection SpellCheckingInspection
const loremWords = [
    "lorem", "ipsum", "dolor", "sit",
    "amet", "consectetur", "adipisicing", "elit",
    "sed", "do", "eiusmod", "tempor",
    "incididunt", "ut", "labore", "et",
    "dolore", "magna", "aliqua", "enim",
    "ad", "minim", "veniam", "quis",
    "nostrud", "exercitation", "ullamco", "laboris",
    "nisi", "aliquip", "ex", "ea",
    "commodo", "consequat", "duis", "aute",
    "irure", "reprehenderit", "in", "voluptate",
    "velit", "esse", "cillum", "eu",
    "fugiat", "nulla", "pariatur", "excepteur",
    "sint", "occaecat", "cupidatat", "non",
    "proident", "sunt", "culpa", "qui",
    "officia", "deserunt", "mollit", "anim",
    "id", "est", "laborum", "perspiciatis",
    "unde", "omnis", "iste", "natus",
    "error", "voluptatem", "accusantium", "doloremque",
    "laudantium", "totam", "rem", "aperiam",
    "eaque", "ipsa", "upwiro", "shaneum", "benum"
];

export namespace strings {

    export function snake2camel(name: string): string {
        // function taken from Angular source code (MIT License)
        const mozHackRegexp = /^moz([A-Z])/;
        const specialCharsRegexp = /([:\-_]+(.))/g;
        return name.replace(specialCharsRegexp, (_: string, separator: string, letter: string, offset: number) =>
            (offset ? letter.toUpperCase() : letter)).replace(mozHackRegexp, "Moz$1");
    }

    export function camel2snake(str: string): string {
        // function taken from Angular source code (MIT License)
        const snakeCaseRegexp = /[A-Z]/g;
        return str.replace(snakeCaseRegexp, (letter: string, pos: number) => (pos ? "-" : "") + letter.toLowerCase());
    }

    export function uppercaseFirstLetter(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    export function lowercaseFirstLetter(str: string): string {
        return str.charAt(0).toLowerCase() + str.slice(1);
    }

    export function removePrefix(str: string, prefix: string): string {
        return str.replace(new RegExp("^" + prefix), "");
    }

    export function hash(str: string): string {

        let hash = 0x811c9dc5;
        for (let i = 0; i < str.length; i++) {
            hash ^= str.charCodeAt(i);
            hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
        }

        return (`0000000${(hash >>> 0).toString(16)}`).substr(-8);
    }

    export function isValidEmail(str: string): boolean {

        if (!str)
            return false;

        if (typeof str !== "string")
            return false;

        if (str.length < 3)
            return false;

        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(str.toLowerCase());
    }

    export function generateLoremIpsum(length: number): string {

        const dot = ".";
        const words = ["Lorem ipsum dolor sit amet"];

        let capitalizeNextWord = false;
        let stringLength = 0;

        for (let i = 0; i < length; ++i) {
            let word = array.getRandomElement(loremWords);

            if (capitalizeNextWord) {
                word = uppercaseFirstLetter(word);
                capitalizeNextWord = false;
                stringLength = 0;
            }

            if (Math.random() > 0.9 && i < length - 1) {
                const useComma = stringLength < 10;
                const separator = useComma ? "," : dot;
                if (!useComma) capitalizeNextWord = true;
                word += separator + " ";
            }

            words.push(word);
            stringLength += 1;
        }

        let result = words.join(" ");

        if (!capitalizeNextWord) result += dot;

        return result;
    }

    export function replaceAll(str: string, find: string | RegExp, replace: string): string {
        if (typeof find === "string")
            return str.split(find).join(replace);
        else return str.replace(find, replace);
    }

    export function removeLineBreaks(str: string): string {
        return str;
        return str.replace(/\n/g, " ");
        //return str.replace(/\r?\n|\r/g, "x");
    }

    export function removeRepeatedSpaces(str: string): string {
        return str.replace(/\s{2,}/g, " ");
    }

    export function removeSpacesBeforePunctuation(str: string): string {
        return str.replace(/\s+([.,?!])/g, "$1");
    }

    export function shorten(str: string, maxLength: number): string {
        if (str.length <= maxLength)
            return str;

        if (maxLength < 3)
            if (maxLength < 0)
                return "";
            else
                return str.substr(0, maxLength);

        return str.substr(0, maxLength - 3) + "...";
    }

    export function encodeBase64(str: string): string {
        // Whatever this does, it works and produces right results with python's base64 module
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode("0x" + p1 as any);
        }));
    }

}
